import { Route } from 'react-router-dom';

import { OnboardingRoute } from '@/app/router/OnboardingRoute';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { AcceptInvitationScreen } from './pages/AcceptInvitationScreen';
import { AuthCallbackScreen } from './pages/AuthCallbackScreen';
import { LegacyAuthRedirect } from './pages/LegacyAuthRedirect';
import { WorkflowSetupScreen } from './pages/WorkflowSetupScreen';
import { WorkspaceInfoScreen } from './pages/WorkspaceInfoScreen';
import { YourDetailsScreen } from './pages/YourDetailsScreen';

// Onboarding screens sit behind ProtectedRoute (user must be signed in) and
// OnboardingRoute (redirects away if onboarding is already complete).
// /auth/callback is the OAuth2 return URL — no guards, code IS the auth.
// The local login/signup/forgot/reset/verify screens were retired
// (google-sign-in-plan GS1): those flows live on signcare-auth's hosted pages;
// old deep links forward into the authorize flow via LegacyAuthRedirect.
export const authRoutes = (
  <>
    <Route path="/auth/callback" element={<AuthCallbackScreen />} />
    <Route path="/login" element={<LegacyAuthRedirect />} />
    <Route path="/signup" element={<LegacyAuthRedirect />} />
    <Route path="/forgot-password" element={<LegacyAuthRedirect />} />
    <Route path="/reset-password" element={<LegacyAuthRedirect />} />
    <Route path="/verify-email" element={<LegacyAuthRedirect />} />
    <Route path="/accept-invitation" element={<AcceptInvitationScreen />} />
    <Route
      path="/onboarding/your-details"
      element={
        <ProtectedRoute>
          <OnboardingRoute>
            <YourDetailsScreen />
          </OnboardingRoute>
        </ProtectedRoute>
      }
    />
    <Route
      path="/onboarding/workspace-info"
      element={
        <ProtectedRoute>
          <OnboardingRoute>
            <WorkspaceInfoScreen />
          </OnboardingRoute>
        </ProtectedRoute>
      }
    />
    <Route
      path="/onboarding/welcome"
      element={
        <ProtectedRoute>
          <OnboardingRoute>
            <WorkflowSetupScreen />
          </OnboardingRoute>
        </ProtectedRoute>
      }
    />
  </>
);
